import { render, staticRenderFns } from "./AlertIconSvg.vue?vue&type=template&id=d3dc6d4a&"
import script from "./AlertIconSvg.vue?vue&type=script&lang=js&"
export * from "./AlertIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports